.root {
    position: relative;
    min-height: 100%;
}
.root > a {
    min-height: auto;
    /* position: absolute; */
    position: relative;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    overflow: hidden;
    z-index: 1;
}
.root > .media {
    height: 100% !important;
}
.advert {
    z-index: 0;
}